import { connect, Dispatch } from 'react-redux';

import AccessoryDetail, { DispatchProps, OwnProps, StateProps } from 'components/pages/accessories/detail/AccessoryDetail';

import { Action, add, cartMessage } from 'redux/modules/shopify';
import { IRootState } from 'redux/root_reducer';
import CartItem from 'types/shopify/CartItem';

const mapStateToProps = ({ display, shopify }: IRootState, ownProps: OwnProps): StateProps => {
    const curProd = shopify.products.find(p => p.id === Number(ownProps.match.params.product_id));
    return {
        isLoading: !shopify.hasLoaded,
        isMobile: display.isMobile,
        product: shopify.hasLoaded
                ? shopify.products.find(p => p.id === Number(ownProps.match.params.product_id))
                : null
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return {
        addToCart: (item: CartItem) => dispatch(add(item)),
        displayCartMessage: (value: string) => dispatch(cartMessage(value))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccessoryDetail);



// WEBPACK FOOTER //
// ./src/containers/pages/accessories/detail/AccessoryDetail.tsx